var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicMinfin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 96,
    viewBox: "0 0 137 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5751_1041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.9288,
    cy: 26.9476,
    rx: 9.763,
    ry: 9.76299,
    fill: "#FFE7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7185 36.3062C69.6856 35.1061 66.7446 31.3702 66.7446 26.9474C66.7446 22.5248 69.6852 18.7891 73.7178 17.5888C72.8341 17.3258 71.8979 17.1846 70.9288 17.1846C65.5368 17.1846 61.1658 21.5556 61.1658 26.9476C61.1658 32.3395 65.5368 36.7106 70.9288 36.7106C71.8982 36.7106 72.8346 36.5693 73.7185 36.3062Z",
    fill: "#F2D0B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2121 37.8354C56.5844 41.091 52.7981 47.1758 52.7981 54.1449V66C52.7981 66 56.4554 71.5 71.6268 71.5C86.7981 71.5 90.4554 66 90.4554 66V54.1449C90.4554 46.8312 86.2855 40.4915 80.1934 37.3735C77.73 39.564 74.4851 40.8946 70.9293 40.8946C67.6309 40.8946 64.5999 39.7496 62.2121 37.8354Z",
    fill: "#F7EABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1658 17C61.1658 14.7909 62.9567 13 65.1658 13H76.6918C78.9009 13 80.6918 14.7909 80.6918 17V24.1577C80.6918 24.1577 78.5997 21.3683 70.9288 21.3683C63.2579 21.3683 61.1658 24.1577 61.1658 24.1577V17Z",
    fill: "#F7EABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7981 18C48.9778 18 54.7982 24.0756 54.7982 31.5703C54.7982 34.0767 54.3282 36.6654 52.9795 38.5312L41.7981 54L30.6168 38.5312C29.2982 36 28.7982 33.8406 28.7982 31.5703C28.7981 24.0756 34.6185 18 41.7981 18ZM41.7981 25.8596C38.7772 25.8596 36.3275 28.4168 36.3275 31.5703C36.3275 34.7238 38.7772 37.281 41.7981 37.281C44.8191 37.281 47.2688 34.7238 47.2688 31.5703C47.2688 28.4168 44.8191 25.8596 41.7981 25.8596Z",
    fill: "#303E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7982 49C77.7982 47.3431 79.1413 46 80.7982 46H104.798C106.455 46 107.798 47.3431 107.798 49V82C107.798 83.6569 106.455 85 104.798 85H80.7982C79.1413 85 77.7982 83.6569 77.7982 82V49Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7982,
    y: 55,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#E7ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7982,
    y: 60,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#E7ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7982,
    y: 70,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#E7ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7982,
    y: 75,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#E7ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7982,
    y: 65,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#E7ECEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.7982,
    cy: 31,
    r: 8,
    fill: "#F7EABC",
    stroke: "#F0F3F5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7982,
    y: 55,
    width: 8,
    height: 7,
    rx: 1,
    fill: "#FECB07"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5751_1041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(28.7982 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicMinfin);
export default __webpack_public_path__ + "static/media/clinic_minfin.025d0f3de5dab8e02320245a6e6bec7f.svg";
export { ForwardRef as ReactComponent };